import { render, staticRenderFns } from "./create-credit-note.vue?vue&type=template&id=34450000&scoped=true"
import script from "./create-credit-note.vue?vue&type=script&lang=js"
export * from "./create-credit-note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34450000",
  null
  
)

export default component.exports